import { render, staticRenderFns } from "./VulnerabilityPOC.vue?vue&type=template&id=48c7d381&scoped=true"
import script from "./VulnerabilityPOC.vue?vue&type=script&setup=true&lang=ts"
export * from "./VulnerabilityPOC.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./VulnerabilityPOC.vue?vue&type=style&index=0&id=48c7d381&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c7d381",
  null
  
)

export default component.exports